// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from 'react-router-dom';

// import PropTypes from 'prop-types';
// import '../../common/CommonText.css'
// import './UserDropdown.css';
// import useFilterStore from "../../../store/useFilterStore";
// import { useAuth } from "../../../contexts/AuthContext";
// import { baseURL } from "../../../services/api";
// import { GetMyDetails } from "../../../services/MyProfileApi";


// const UserDropdown = ({ isOpen, onClose }) => {
//     const popupRef = useRef(null);
//     const navigate = useNavigate();
//     const { handleLogout } = useAuth();
    
//     const [userData, setUserData] = useState([]);

//     const profile_url = userData?.profile_pic
//       ? `${baseURL.slice(0, -1)}/${userData.profile_pic.replace(/^\//, "")}`
//       : null;
  
//     useEffect(() => {
//       fetchUserDetails();
//     }, []);
    
//     async function fetchUserDetails() {
//         const response = await GetMyDetails();
//         setUserData(response);
//     }
//     const handleLogoutClick = () => {
//         handleLogout(); // Use auth context logout
//         onClose(); // Close the popup
//         useFilterStore.getState().clearAllFilters();
//         // Don't call navigate here - the auth context will handle the redirect
//     };

//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (popupRef.current && !popupRef.current.contains(event.target)) {
//                 onClose(); 
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);

//         return () => {
//             document.removeEventListener("mousedown", handleClickOutside);
//         };
//     }, [onClose]);

//     if (!isOpen) return null;

//     const handlePersonalDetailClick = () => {
//         navigate(`/my-profile`); 
//         onClose();
//     };
    
//     const handleMyOrgClick = () =>{
//         navigate('/my-organization')
//         onClose();
//     }


// return (
//     <div className="my-profile-popup-overlay" >
//         <div className="myprofile-popup-container " ref={popupRef}>
//             <div className='myprofile-popup'>
//                 <div className="user-info user-dpdn">
//                     <img
//                         src={profile_url || "/assets/no-profile.png"}
//                         alt="user profile"
//                         className="user-image"
//                     />
//                     <div className="username-container">
//                     <span className="user-name common-text ftw-4 black">
//                         {userData?.full_name}
//                     </span>
//                     <span className="role common-text  ftw-4 dk-gray">
//                         {userData?.role?.name}
//                     </span>
//                     </div>
//                 </div>
//                 <button className='my-profile-option'onClick={handlePersonalDetailClick}>
//                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
//                     <path d="M11.5 15H7C5.93913 15 4.92172 15.4214 4.17157 16.1716C3.42143 16.9217 3 17.9391 3 19V21" stroke="#454545" stroke-linecap="round" stroke-linejoin="round"/>
//                     <path d="M21.378 16.626C21.7763 16.2277 22.0001 15.6874 22.0001 15.124C22.0001 14.5607 21.7763 14.0204 21.378 13.622C20.9796 13.2237 20.4393 12.9999 19.876 12.9999C19.3126 12.9999 18.7723 13.2237 18.374 13.622L14.364 17.634C14.1262 17.8716 13.9522 18.1654 13.858 18.488L13.021 21.358C12.9959 21.4441 12.9944 21.5353 13.0166 21.6221C13.0389 21.7089 13.084 21.7882 13.1474 21.8516C13.2108 21.915 13.2901 21.9601 13.3769 21.9824C13.4637 22.0046 13.5549 22.0031 13.641 21.978L16.511 21.141C16.8336 21.0468 17.1274 20.8728 17.365 20.635L21.378 16.626Z" stroke="#454545" stroke-linecap="round" stroke-linejoin="round"/>
//                     <path d="M10 11C12.2091 11 14 9.20914 14 7C14 4.79086 12.2091 3 10 3C7.79086 3 6 4.79086 6 7C6 9.20914 7.79086 11 10 11Z" stroke="#454545" stroke-linecap="round" stroke-linejoin="round"/>
//                 </svg>
//                     <span className='common-text dk-gray ftw-4'>My Profile</span>
//                 </button>
//                 <button className='my-profile-option my-profile-option-logout'onClick={handleMyOrgClick}>
//                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
//                     <path d="M6 22V4C6 3.46957 6.21071 2.96086 6.58579 2.58579C6.96086 2.21071 7.46957 2 8 2H16C16.5304 2 17.0391 2.21071 17.4142 2.58579C17.7893 2.96086 18 3.46957 18 4V22H6Z" stroke="#454545" stroke-linecap="round" stroke-linejoin="round"/>
//                     <path d="M6 12H4C3.46957 12 2.96086 12.2107 2.58579 12.5858C2.21071 12.9609 2 13.4696 2 14V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H6" stroke="#454545" stroke-linecap="round" stroke-linejoin="round"/>
//                     <path d="M18 9H20C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11V20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22H18" stroke="#454545" stroke-linecap="round" stroke-linejoin="round"/>
//                     <path d="M10 6H14" stroke="#454545" stroke-linecap="round" stroke-linejoin="round"/>
//                     <path d="M10 10H14" stroke="#454545" stroke-linecap="round" stroke-linejoin="round"/>
//                     <path d="M10 14H14" stroke="#454545" stroke-linecap="round" stroke-linejoin="round"/>
//                     <path d="M10 18H14" stroke="#454545" stroke-linecap="round" stroke-linejoin="round"/>
//                 </svg>
//                     <span className='common-text dk-gray ftw-4'>My Organization</span>
//                 </button>
//                 <button className='my-profile-option my-profile-option-logout' onClick={handleLogoutClick}>
//                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
//                     <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="#454545" stroke-linecap="round" stroke-linejoin="round"/>
//                     <path d="M16 17L21 12L16 7" stroke="#454545" stroke-linecap="round" stroke-linejoin="round"/>
//                     <path d="M21 12H9" stroke="#454545" stroke-linecap="round" stroke-linejoin="round"/>
//                 </svg>
//                     <span className='common-text dk-gray ftw-4'>Log Out</span>
//                 </button>       
//             </div>
//         </div>
//     </div>
// );
// };

// UserDropdown.propTypes = {
// isOpen: PropTypes.bool.isRequired,
// onClose: PropTypes.func.isRequired,
// };

// export default UserDropdown; 


import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import '../../common/CommonText.css'
import './UserDropdown.css';
import useFilterStore from "../../../store/useFilterStore";
import { useAuth } from "../../../contexts/AuthContext";
import { baseURL } from "../../../services/api";
import { GetMyDetails } from "../../../services/MyProfileApi";
import LogoutConfirmationPopup from "../LogoutConfirmation/LogoutConfirmationPopup";
import { useTranslation } from "react-i18next";

const UserDropdown = ({ isOpen, onClose, isRestricted }) => {
    const popupRef = useRef(null);
    const navigate = useNavigate();
    const { handleLogout } = useAuth();
    const { t } = useTranslation();
    const [userData, setUserData] = useState([]);
    const [showLogoutPopup, setShowLogoutPopup] = useState(false);

    const profile_url = userData?.profile_pic
      ? `${baseURL.slice(0, -1)}/${userData.profile_pic.replace(/^\//, "")}`
      : null;
  
    useEffect(() => {
      fetchUserDetails();
    }, []);
    
    async function fetchUserDetails() {
        const response = await GetMyDetails();
        setUserData(response);
    }

    const handleLogoutClick = () => {
        setShowLogoutPopup(true);
    };

    const confirmLogout = () => {
        handleLogout();
        setShowLogoutPopup(false);
        onClose();
        useFilterStore.getState().clearAllFilters();
    };

    const cancelLogout = () => {
        setShowLogoutPopup(false);
    };

    useEffect(() => {

            if (showLogoutPopup) return;

            const handleClickOutside = (event) => {
                if (popupRef.current && !popupRef.current.contains(event.target)) {
                    onClose(); 
                }
            };
            document.addEventListener("mousedown", handleClickOutside);

            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [onClose, showLogoutPopup]);
    if (!isOpen) return null;

    const handlePersonalDetailClick = () => {
        navigate(`/my-profile`); 
        onClose();
    };
    
    const handleMyOrgClick = () =>{
        navigate('/my-organization')
        onClose();
    }

    return (
        <>
            <div className="my-profile-popup-overlay" >
                <div className="myprofile-popup-container " ref={popupRef}>
                    <div className='myprofile-popup'>
                        <div className="user-info user-dpdn">
                            <img
                                src={profile_url || "/assets/no-profile.png"}
                                alt="user profile"
                                className="user-image"
                            />
                            <div className="username-container">
                                <span className="user-name common-text ftw-4 black">
                                    {userData?.full_name}
                                </span>
                                <span className="role common-text  ftw-4 dk-gray">
                                    {userData?.role?.name}
                                </span>
                            </div>
                        </div>
                        {true && (
                            <>
                                <button className='my-profile-option' onClick={handlePersonalDetailClick}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M11.5 15H7C5.93913 15 4.92172 15.4214 4.17157 16.1716C3.42143 16.9217 3 17.9391 3 19V21" stroke="#454545" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M21.378 16.626C21.7763 16.2277 22.0001 15.6874 22.0001 15.124C22.0001 14.5607 21.7763 14.0204 21.378 13.622C20.9796 13.2237 20.4393 12.9999 19.876 12.9999C19.3126 12.9999 18.7723 13.2237 18.374 13.622L14.364 17.634C14.1262 17.8716 13.9522 18.1654 13.858 18.488L13.021 21.358C12.9959 21.4441 12.9944 21.5353 13.0166 21.6221C13.0389 21.7089 13.084 21.7882 13.1474 21.8516C13.2108 21.915 13.2901 21.9601 13.3769 21.9824C13.4637 22.0046 13.5549 22.0031 13.641 21.978L16.511 21.141C16.8336 21.0468 17.1274 20.8728 17.365 20.635L21.378 16.626Z" stroke="#454545" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M10 11C12.2091 11 14 9.20914 14 7C14 4.79086 12.2091 3 10 3C7.79086 3 6 4.79086 6 7C6 9.20914 7.79086 11 10 11Z" stroke="#454545" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    <span className='common-text dk-gray ftw-4'>{t('My Profile')}</span>
                                </button>
                                <button className='my-profile-option my-profile-option-logout' onClick={handleMyOrgClick}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M6 22V4C6 3.46957 6.21071 2.96086 6.58579 2.58579C6.96086 2.21071 7.46957 2 8 2H16C16.5304 2 17.0391 2.21071 17.4142 2.58579C17.7893 2.96086 18 3.46957 18 4V22H6Z" stroke="#454545" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M6 12H4C3.46957 12 2.96086 12.2107 2.58579 12.5858C2.21071 12.9609 2 13.4696 2 14V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H6" stroke="#454545" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M18 9H20C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11V20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22H18" stroke="#454545" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M10 6H14" stroke="#454545" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M10 10H14" stroke="#454545" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M10 14H14" stroke="#454545" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M10 18H14" stroke="#454545" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    <span className='common-text dk-gray ftw-4'>{t('My Organization')}</span>
                                </button>
                            </>
                        )}
                        <button className='my-profile-option my-profile-option-logout' onClick={handleLogoutClick}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="#454545" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M16 17L21 12L16 7" stroke="#454545" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M21 12H9" stroke="#454545" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            <span className='common-text dk-gray ftw-4'>{t('Log Out')}</span>
                        </button>       
                    </div>
                </div>
            </div>

            <LogoutConfirmationPopup
                isOpen={showLogoutPopup}
                onConfirm={confirmLogout}
                onClose={cancelLogout}
            />
        </>
    );
};

UserDropdown.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default UserDropdown;